import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = (process.env.REACT_APP_SITE_URL || process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

// Public site origin — use for all canonical/JSON-LD URLs (never the API/backend origin).
export const SITE_URL = BASE;

export default function Seo({
  title,
  description,
  path = "",
  image,
  jsonLd,
  noindex = false,
  type = "website",
}) {
  const url = `${BASE}${path}`;
  const img = image && !/^https?:/.test(image) ? `${BASE}${image}` : image;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <html lang="fr-BE" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="alternate" hrefLang="fr-BE" href={url} />
      <link rel="alternate" hrefLang="fr-LU" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="fr_BE" />
      <meta property="og:site_name" content="Smarti Renew" />
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {img && <meta name="twitter:image" content={img} />}
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": ["Organization", "OnlineStore"],
  name: "Smarti Renew",
  legalName: "Smarti Group SRL",
  description:
    "Smartphones reconditionnés premium (iPhone, Samsung, Google Pixel, iPad, Apple Watch) testés dans notre atelier en Belgique, garantis 36 mois, livrés partout en Europe.",
  url: BASE,
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_smarti-renew-store/artifacts/ej6nyxhc_Copie-de-image1-1%20%281%29.png",
  vatID: "BE 1019.893.830",
  taxID: "BE 1019.893.830",
  telephone: "+32 63 50 03 54",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Arlon",
    postalCode: "6700",
    addressCountry: "BE",
  },
  areaServed: { "@type": "Country", name: "Belgique" },
  sameAs: [
    "https://www.facebook.com/smarti.belgique/",
    "https://www.instagram.com/smarti_be/",
    "https://smarti-repair.be",
    "https://smarti-glass.be",
  ],
};

export const breadcrumbJsonLd = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.name,
    item: `${BASE}${c.path}`,
  })),
});
